import store from 'src/stores';
import {
  serverInfoPromiseAtom,
  setServersInfoAtom,
  userCountryCodeAtom,
} from 'src/stores/auth/atoms';
import { AzarUser } from 'src/types/AzarUser';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
import { getAtomWithStorage } from 'src/utils/localStorageUtils';

const ICE_SERVER_REFRESH_THRESHOLD = 5;

const iceServersAtom = getAtomWithStorage<AzarUser['iceServers']>('iceServersV2', []);

/**
 * ice server manager
 * ice server를 관리하는 클래스
 */
export class IceServerManager {
  private static instance: IceServerManager;

  private emptyIceCandidateErrorCount = 0;

  static getInstance(): IceServerManager {
    if (!IceServerManager.instance) {
      IceServerManager.instance = new IceServerManager();
    }
    return IceServerManager.instance;
  }

  public async fetchIceServers() {
    const hasUpdatedServersInfo = await store.set(setServersInfoAtom);
    if (hasUpdatedServersInfo) {
      this.emptyIceCandidateErrorCount = 0;
    }
  }

  public async getIceServers() {
    await store.get(serverInfoPromiseAtom);
    return store.get(iceServersAtom);
  }

  public setIceServers(iceServers: AzarUser['iceServers']) {
    store.set(iceServersAtom, iceServers);
  }

  public cleanIceServers() {
    this.setIceServers([]);
  }

  public handleEmptyIceCandidateError() {
    this.emptyIceCandidateErrorCount++;
    if (this.emptyIceCandidateErrorCount > ICE_SERVER_REFRESH_THRESHOLD) {
      this.fetchIceServers();
    }
  }

  public async reportConnectionFail({
    errorMessage,
    generalConnectionAddress,
  }: {
    errorMessage: string;
    generalConnectionAddress?: string[];
  }) {
    pushEvent({
      eventType: EVENT_TYPE.DEBUG,
      eventName: EVENT_NAME.GENERAL_CONNECTION_FAIL,
      eventParams: {
        generalConnectionFailInfo: errorMessage,
        generalConnectionFailType: 'TURN',
        country: store.get(userCountryCodeAtom),
        generalConnectionAddress,
      },
    });
  }
}
